export default function phq9Score(phq9) {
  return phq9.keySeq().reduce((sum, key) => {
    return keys.includes(key)
      ? sum += scoreForValue(phq9.get(key))
      : sum;
  }, 0);
};

const keys = [
  'lackInterest',
  'feelingDown',
  'abnormalSleep',
  'lackEnergy',
  'abnormalEating',
  'lackSelfConfidence',
  'troubleConcentrating',
  'abnormalMovements',
  'suicidalThoughts'
];
  
function scoreForValue(val) {
  return {
    [Answers.notAtAll]: 0,
    [Answers.severalDays]: 1,
    [Answers.overHalfOfDays]: 2,
    [Answers.nearlyEveryDay]: 3
  }[val];
}

const Answers = Object.freeze({
  notAtAll: 'notAtAll',
  severalDays: 'severalDays',
  overHalfOfDays: 'moreThanHalfTheDays',
  nearlyEveryDay: 'nearlyEveryDay'
});



// WEBPACK FOOTER //
// ./src/business-logic/phq9-score.js